import React from 'react';
import UserDataOnDemand from 'UserData/Connector/Apollo/Fetch/UserDataOnDemandConnectorApollo';
import AuthLoginByEmailAndPasswordForm from '@dietlabs/components/src/Auth/Login/ByEmailAndPassword/AuthLoginByEmailAndPasswordForm';
import LoginConnector from '@dietlabs/components/src/Auth/Login/ByEmailAndPassword/Connector/Apollo/Login/LoginConnectorApollo';
import { PATH_COUPON_ACTIVATE } from '../routes';

class CouponLoginContainer extends React.Component {
    render() {
        return (
            <LoginConnector>
                {({ ...login }) => (
                    <UserDataOnDemand>
                        {({ ...userDataOnDemand }) => (
                            <AuthLoginByEmailAndPasswordForm
                                redirectToPathAfterSuccess={
                                    PATH_COUPON_ACTIVATE
                                }
                                {...login}
                                {...userDataOnDemand}
                            />
                        )}
                    </UserDataOnDemand>
                )}
            </LoginConnector>
        );
    }
}

export default CouponLoginContainer;
